var analytics = function () {

  var publicMethods = {};

  var links = document.querySelectorAll('a[data-analytics-event]');

  publicMethods.init = function() {

    if (!links.length) return;
    
    for (var i = 0; i < links.length; i++) {
			
			(function (i) {
				
				links[i].addEventListener('click', handleLinkClick);

			})(i);
		
		}

  };

  publicMethods.track = function(category, action, label) {

    if (typeof gtag === 'undefined') return;

    gtag('event', 'gibe_custom_event', {
      'event_category': category,
      'event_action': action,
      'event_label': label
    });

  };

  publicMethods.page = function(url, title) {

    if (typeof gtag === 'undefined') return;

    gtag('event', 'page_view', {
      'page_location': url
    });

  };

  function handleLinkClick(e) {

    var eventParts = e.target.getAttribute('data-analytics-event').split('|');
		analytics.track(eventParts[0], eventParts[1], eventParts[2]);
		e.preventDefault();

  };

  return publicMethods;

}();

analytics.init();
